// Click-to-zoom inside the theme's full-screen product image viewer (mouse only).
// Click an image to zoom in at that point, move to pan, click again to zoom out.
// Touch devices keep the theme's pinch-to-zoom.
const SCALE = 2.5;
const VIEWER = '.dialog-zoomed-gallery__dialog';
const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

function origin(container, event) {
  const rect = container.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;
  return `${Math.min(100, Math.max(0, x))}% ${Math.min(100, Math.max(0, y))}%`;
}

function reset(container) {
  container.classList.remove('is-zoomed');
  const img = container.querySelector('img');
  if (img) {
    img.style.transform = '';
    img.style.transformOrigin = '';
  }
}

document.addEventListener('click', (event) => {
  if (!FINE_POINTER.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
  const img = event.target.closest?.(`${VIEWER} img`);
  if (!img) return;
  const container = img.parentElement;
  if (container.classList.contains('is-zoomed')) return reset(container);
  document.querySelectorAll(`${VIEWER} .is-zoomed`).forEach(reset);
  container.classList.add('is-zoomed');
  img.style.transformOrigin = origin(container, event);
  img.style.transform = `scale(${SCALE})`;
});

document.addEventListener('pointermove', (event) => {
  if (event.pointerType !== 'mouse') return;
  const container = event.target.closest?.(`${VIEWER} .is-zoomed`);
  if (!container) return;
  const img = container.querySelector('img');
  if (img) img.style.transformOrigin = origin(container, event);
});

// Zoom out when the viewer closes or the shopper scrolls to another image.
document.addEventListener('close', (event) => {
  if (event.target.matches?.(VIEWER)) event.target.querySelectorAll('.is-zoomed').forEach(reset);
}, true);
document.addEventListener('scroll', (event) => {
  const viewer = event.target.closest?.(VIEWER) ?? (event.target.matches?.(VIEWER) ? event.target : null);
  viewer?.querySelectorAll('.is-zoomed').forEach(reset);
}, true);
